import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useNotifications } from '../../context/NotificationContext';
import {
  LayoutDashboard,
  CreditCard,
  DollarSign,
  Folder,
  Package,
  ShoppingCart,
  Users,
  FileText,
  Shield,
  TrendingUp,
  Image,
  Gift,
  Settings,
  User,
  BarChart3,
  MessageSquare,
  Mail,
  Tag,
  Slack,
  Star,
  Truck,
  Briefcase,
  Info,
  Building2,
  Globe
} from 'lucide-react';
import './Layout.css';

function Sidebar() {
  const { isAdmin } = useAuth();
  const { badges } = useNotifications();

  const menuItems = [
    { path: '/', label: 'Tableau de bord', icon: LayoutDashboard, adminOnly: false },
    { path: '/pos', label: 'Point de vente', icon: CreditCard, adminOnly: false },
    { path: '/sales', label: 'Ventes', icon: DollarSign, adminOnly: false },
    { path: '/categories', label: 'Catégories', icon: Folder, adminOnly: false },
    { path: '/brands', label: 'Marques', icon: Slack, adminOnly: false },
    { path: '/products', label: 'Produits', icon: Package, adminOnly: false },
    { path: '/orders', label: 'Commandes', icon: ShoppingCart, adminOnly: false, badge: badges.orders },
    { path: '/shipments', label: 'Livraisons', icon: Truck, adminOnly: false },
    { path: '/clients', label: 'Clients', icon: Users, adminOnly: false, badge: badges.clients },
    { path: '/quotes', label: 'Devis', icon: FileText, adminOnly: false },
    { path: '/warranties', label: 'Garanties', icon: Shield, adminOnly: false },
    { path: '/stock-movements', label: 'Mouvements de stock', icon: TrendingUp, adminOnly: false },
    { path: '/sliders', label: 'Sliders', icon: Image, adminOnly: false },
    { path: '/sites-vitrines', label: 'Sites vitrines', icon: Globe, adminOnly: true },
    { path: '/promo-packs', label: 'Packs promo', icon: Gift, adminOnly: false },
    { path: '/coupons', label: 'Coupons', icon: Tag, adminOnly: false },
    { path: '/contacts', label: 'Messages de contact', icon: MessageSquare, adminOnly: false, badge: badges.contacts },
    { path: '/inquiries', label: 'Demandes B2B', icon: Briefcase, adminOnly: true },
    { path: '/reviews', label: 'Avis clients', icon: Star, adminOnly: true },
    { path: '/newsletter', label: 'Newsletter', icon: Mail, adminOnly: false, badge: badges.newsletter },
    { path: '/page-about', label: 'Page À propos', icon: Info, adminOnly: false },
    { path: '/page-b2b', label: 'Page B2B', icon: Building2, adminOnly: false },
    { path: '/company-settings', label: 'Paramètres société', icon: Settings, adminOnly: false },
    { path: '/users', label: 'Utilisateurs', icon: User, adminOnly: true },
    { path: '/analytics', label: 'Analytiques', icon: BarChart3, adminOnly: true },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src="/assets/img/logo.png" alt="Tech360" />
        </div>
        <h2>Tech360</h2>
      </div>
      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          if (item.adminOnly && !isAdmin()) return null;
          const IconComponent = item.icon;
          const hasBadge = item.badge && item.badge > 0;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              title={item.label}
              className={({ isActive }) =>
                isActive ? 'sidebar-link active' : 'sidebar-link'
              }
            >
              <IconComponent className="sidebar-icon" size={20} />
              <span className="sidebar-label">{item.label}</span>
              {hasBadge && (
                <span className="sidebar-badge">{item.badge > 99 ? '99+' : item.badge}</span>
              )}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}

export default Sidebar;
